import { Transition } from '@headlessui/react';
import { Fragment } from 'react';

import { CollectionIcon } from '~components/icons/CollectionIcon';
import { ThumbnailIcon } from '~components/icons/ThumbnailIcon';
import { Asset } from '~modules/media-library/model/Asset';
import { AssetActions } from '~modules/media-library/model/AssetActions';
import { isAssetCollection } from '~modules/media-library/model/AssetFactory';
import { AssetIdTag } from '~modules/media-library/view/AssetIdTag';
import { FavouriteButton } from '~modules/media-library/view/FavouriteButton';
import { Bubbles } from '~modules/media-library/view/MetaBubble/Bubbles';

type PanelFigureProps = {
  asset: Asset;
  AssetActions: AssetActions;
};

export function PanelFigure({ asset, AssetActions }: PanelFigureProps) {
  const isCollection = isAssetCollection(asset);
  const onCopyId = asset.actions.copyId ? AssetActions.onCopyId : undefined;
  const onToggleFavourite = asset.actions.favourites ? AssetActions.onToggleFavourite : undefined;

  return (
    <figure className="ml--detail-modal--panel-figure relative flex justify-center items-center w-full min-h-24 max-h-80 overflow-hidden transition bg-black bg-opacity-10 p-0 m-0">
      {!!asset.previews.details ? (
        <Transition
          appear
          as={Fragment}
          enter="ease-out duration-700"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
          show
        >
          <img
            className="select-none max-w-full max-h-80 inline-block p-0 m-0"
            src={asset.previews.details}
            alt={asset.attributes.title}
          />
        </Transition>
      ) : (
        <div
          className={`w-full h-full flex items-center justify-center min-h-24 p-4 ${
            isCollection ? 'bg-gradient-collection text-white' : ''
          }`}
        >
          {isCollection ? (
            <CollectionIcon className="w-1/2 h-1/2 mt-2" />
          ) : (
            <ThumbnailIcon className="text-black opacity-30 w-1/2" />
          )}
        </div>
      )}
      <AssetIdTag asset={asset} onClick={onCopyId} className="absolute bottom-0 right-0 m-3" />
      <Bubbles asset={asset} className="absolute top-0 right-0 p-2 bg-opacity-100 justify-between" />
      <div className="absolute top-0 left-0 p-2 bg-opacity-100 flex justify-between">
        <FavouriteButton assetId={asset.id} onToggle={onToggleFavourite} isFavourite={asset.infos.isFavourite} />
      </div>
    </figure>
  );
}
